import { createCollection } from '@tanstack/db';
import { queryCollectionOptions } from '@tanstack/query-db-collection';

import { getDynLabelMap } from '@/api/generated/digiVAPI';
import { queryClient } from '@/services/queryClient';

export const labelMapCollection = createCollection(
  queryCollectionOptions({
    id: 'label-map-collection',
    queryClient,
    queryKey: ['label-map-collection'],
    getKey: (item) => item.ID,
    queryFn: async () => {
      const response = await getDynLabelMap({
        page: 1,
        size: 1000,
        sort: [
          {
            field: 'Naam',
            direction: 'asc',
          },
        ],
      });

      return response.objects ?? [];
    },
  })
);
